import React from "react";
import logo from "assets/img/logo2.png";

export default function HeaderLogo() {
  return (
    <div>
      <img src={logo} className="logo" alt="logo" width={300} height="auto" />
    </div>
  );
}
